import { AnalyticsBrowser } from "@segment/analytics-next";

import { isDev } from "@/lib/env";
import { devLog } from "../utils";

import type { GenericSegmentEventProperties } from "./segment-events";

const analytics = AnalyticsBrowser.load({ writeKey: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY! });

export function clientSideIdentify(userId: string, traits: Record<string, unknown>) {
  if (isDev()) return;

  try {
    analytics.identify(userId, traits);
  } catch (error) {
    console.warn("Client-side Segment identify failed:", error);
  }
}

export function clientSideTrack({ event, properties, userId }: GenericSegmentEventProperties) {
  if (isDev()) {
    devLog(`[${event} Client Event]\n`, properties);
    return;
  }

  try {
    const eventProperties = userId ? { ...properties, userId } : properties;
    analytics.track(event, eventProperties);
  } catch (error) {
    console.warn("Client-side Segment track failed:", error);
  }
}

export { analytics };
